import React from "react";
import AdminFeatureTour, {
  markTourSeen,
  shouldAutoStartTour,
} from "../../components/AdminFeatureTour";

export const THEMEUPDATE_TOUR_STORAGE_KEY = "sl_admin_themeupdate_tour_seen_v1";

export const THEMEUPDATE_TOUR_STEPS = [
  {
    id: "welcome",
    target: "tour-gc-header",
    title: "Game Content",
    body: "This page is where you add quiz questions for the theme.",
  },
  {
    id: "questions",
    target: "tour-gc-quiz",
    title: "Add Questions",
    body: "Add, edit, delete, or CSV-import questions. Each question has its own options and is saved to the questions table.",
  },
];

export default function ThemeUpdateFeatureTour({ open, onClose }) {
  return <AdminFeatureTour open={open} onClose={onClose} steps={THEMEUPDATE_TOUR_STEPS} />;
}

export function markThemeUpdateTourSeen() {
  markTourSeen(THEMEUPDATE_TOUR_STORAGE_KEY);
}

export function shouldAutoStartThemeUpdateTour() {
  return shouldAutoStartTour(THEMEUPDATE_TOUR_STORAGE_KEY);
}
